import { resolveQmsDashboardDateRange } from "./qmsDashboardUtils";

export const QMS_TIME_PERIOD_FIELDS = new Set([
  "periodDay",
  "periodWeek",
  "periodMonth",
  "periodQuarter",
  "periodHalfYear",
  "periodYear",
]);

function toIsoDate(date) {
  if (!date || Number.isNaN(date.getTime())) return "";
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

function getIsoWeekKey(date) {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dayNum = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  const weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  return `${d.getUTCFullYear()}-W${String(weekNo).padStart(2, "0")}`;
}

const EMPTY_PERIODS = {
  periodDay: "—",
  periodWeek: "—",
  periodMonth: "—",
  periodQuarter: "—",
  periodHalfYear: "—",
  periodYear: "—",
};

export function buildPeriodFieldsFromDate(rawDate) {
  if (!rawDate) return { ...EMPTY_PERIODS };

  const date = rawDate instanceof Date ? rawDate : new Date(rawDate);
  if (Number.isNaN(date.getTime())) return { ...EMPTY_PERIODS };

  const month = date.getMonth() + 1;
  const quarter = Math.floor(date.getMonth() / 3) + 1;
  const half = month <= 6 ? "H1" : "H2";
  const year = date.getFullYear();

  return {
    periodDay: toIsoDate(date),
    periodWeek: getIsoWeekKey(date),
    periodMonth: `${year}-${String(month).padStart(2, "0")}`,
    periodQuarter: `${year}-Q${quarter}`,
    periodHalfYear: `${year}-${half}`,
    periodYear: String(year),
  };
}

export function resolveReportFilterSpanDays(filters = {}) {
  if (filters.dateRange === "All Time" && !filters.dateFrom && !filters.dateTo) {
    return null;
  }

  const resolved = resolveQmsDashboardDateRange({
    preset: filters.dateRange,
    startDate: filters.dateFrom,
    endDate: filters.dateTo,
  });

  if (!resolved.startDate || !resolved.endDate) return null;

  const start = new Date(`${resolved.startDate}T00:00:00`);
  const end = new Date(`${resolved.endDate}T23:59:59`);
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return null;

  return Math.max(1, Math.ceil((end - start) / 86400000) + 1);
}

export function isTimePeriodField(field) {
  return QMS_TIME_PERIOD_FIELDS.has(field);
}

export function sortPivotRowsChronologically(rows, groupField) {
  if (!isTimePeriodField(groupField)) return rows;
  return [...rows].sort((a, b) => String(a.rowKey).localeCompare(String(b.rowKey)));
}
